export default __webpack_public_path__ + "static/media/APIrevised2.2cc96163.mp4";